import React from 'react'
import TopicView from './TopicView.js'
import './style.css'

export default ({ match }) => {
  return (
    <div className="learn-topic-container">
      <TopicView id={match.params.id} />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Learn/Topic/index.js